import { render, staticRenderFns } from "./feedbackModal.vue?vue&type=template&id=35ec4ef2&scoped=true&"
import script from "./feedbackModal.vue?vue&type=script&lang=ts&"
export * from "./feedbackModal.vue?vue&type=script&lang=ts&"
import style0 from "./feedbackModal.vue?vue&type=style&index=0&id=35ec4ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec4ef2",
  null
  
)

export default component.exports